@if (dashboard) {
    <div class="name-wrapper">
        <h1 [title]="dashboard.name">{{ dashboard.name }}</h1>
        <div class="btn-group">
            <cc-button
                class="hs-db-header-save"
                [type]="'outline'"
                [disabled]="!isDirty || dashboard.privilege === 'VIEW'"
                (pressed)="editAction.emit('save')"
            >
                save
            </cc-button>

            <cc-button
                class="hs-db-header-cancel"
                [type]="'outline'"
                (pressed)="editAction.emit('cancel')"
            >
                cancel
            </cc-button>

            <cc-button
                class="hs-db-header-revert"
                [type]="'outline'"
                [disabled]="!isDirty"
                (pressed)="editAction.emit('revert')"
            >
                revert
            </cc-button>
        </div>
    </div>

    @if (group) {
        <ddv-peer-carousel
            [group]="group"
            [selectedDashboardId]="dashboard.id?.toString() ?? '0'"
            (selectedDashboardIdChange)="dashboardSwitch.emit($event)"
        >
        </ddv-peer-carousel>
    }
}
